import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ConstrainedField } from '@app/shared/models/constrained-field';

@Component({
  selector: 'dynamic-cell-form',
  templateUrl: './dynamic-cell-form.component.html',
  styleUrls: ['./dynamic-cell-form.component.scss'],
})
export class DynamicCellFormComponent {
  @Input() public fields: Array<ConstrainedField> = [];
  @Input('useFormGroup') formGroup!: FormGroup;

  public transformTooltip(text: string, separator?: string): string[] {
    if (separator) {
      return text.split(separator);
    }
    else if (text.includes('\n')) {
      return text.split('\n');
    }
    else {
      return [text];
    }
  }

  public filteredFields(): Array<ConstrainedField> {
    return this.fields.filter(f => !f.hidden);
  }
}
